import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { CardBody } from "reactstrap";
import { StyledIconButton, PlusIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";

import { store, setIsAddPeripheralClicked } from "../../../store";
import { setSelectedRowData, setIsCashManagementModified } from "../../store";
import { store as userStore } from "@components/VerticalLayout/store";

import { CashManagementConfigure } from "@pages/Peripherals/CashManagement/CashManagementConfigure";
import { ConfirmationDeleteMessage } from "@components/Common/ConfirmationDeleteMessage";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import DropDownAction from "../../../DropDownAction";
import CashManagementActionColumn from "./CashManagementActionColumn";
import { AlertDeletePeripheralMessage } from "@components/Common/AlertDeletePeripheralMessage";
import { ConfirmationMessageEditPeripheral } from "@components/Common/ConfirmationMessageEditPeripheral";
import { useAuthHeader } from "../../../../../../api/headersKeycloak";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import { PERIPHERAL_FORM_CARD_STYLE } from "@pages/Applications/DeviceAssociateModal/styles";

type CustomColumnProps = {
    indexOFColumn: number;
    columnName: string;
    customJsx: React.ReactNode;
};
type DeviceAssociateModalType = {
    setIsDeviceAssociateModalOpened: Function;
    isDeviceAssociateModalOpened: boolean;
    rowData: any;
    dataIsUpdated: boolean | number;
    setDataIsUpdated: Function;
};
export default function CashManagement({
    setIsDeviceAssociateModalOpened,
    isDeviceAssociateModalOpened,
    rowData,
    dataIsUpdated,
    setDataIsUpdated,
}: DeviceAssociateModalType) {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { userID, franchiseID } = useSnapshot(userStore);
    const { isAddPeripheralClicked } = useSnapshot(store);
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [
        isDataCashManagementUpdated,
        setIsDataCashManagementUpdated,
    ] = React.useState<boolean | number>(false);
    // Mirror the printer pattern (Printer.tsx): when the inner cash-management
    // editor persists a change, flag it so closing the modal refreshes the
    // main table.
    useEffect(() => {
        if (isDataCashManagementUpdated !== false) {
            setIsCashManagementModified(true);
        }
    }, [isDataCashManagementUpdated]);
    const [
        isConfirmationEditRunning,
        setIsConfirmationEditRunning,
    ] = React.useState<boolean>(false);
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [
        isAddNewCashManagementButtonClicked,
        setIsAddNewCashManagementButtonClicked,
    ] = React.useState(false);
    const [isEdited, setIsEdited] = React.useState<boolean>(false);
    const [editedData, setEditedData] = React.useState<any>([]);
    const [data, setData] = React.useState<any>([]);
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);
    const [
        isModalDeleteAssociatePeripheralOpened,
        setIsModalDeleteAssociatePeripheralOpened,
    ] = React.useState<boolean>(false);
    const [inputDesignation, setInputDesignation] = React.useState<boolean>(
        false
    );
    const [inputMarque, setInputMarque] = React.useState<boolean>(false);
    const [inputIp, setInputIp] = React.useState<boolean>(false);

    let arrayOfCustomColumns: CustomColumnProps[] = [
        {
            indexOFColumn: 0,
            columnName: t("Designation"),
            customJsx: (e: any) => {
                return <div>{e.selectedRow[t("Designation")]}</div>;
            },
        },
        {
            indexOFColumn: 999,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CashManagementActionColumn
                    rowData={rowData}
                    element={e.selectedRow}
                    isDataCashManagementUpdated={isDataCashManagementUpdated}
                />
            ),
        },
    ];

    function customJsxComponent(e: any) {
        return (
            (e.selectedRow.original["Application"] !== "" ||
                e.selectedRow.original["Périphérique"] !== "") && (
                <div className="w-100 d-flex justify-content-center">
                    <DropDownAction
                        element={e}
                        setEditedData={setEditedData}
                        setInputIp={setInputIp}
                    />
                </div>
            )
        );
    }

    useEffect(() => {
        setSelectedRowData(rowData);
    }, [rowData]);

    return (
        <React.Fragment>
            <CardBody className="p-1" style={PERIPHERAL_FORM_CARD_STYLE}>
                <div
                    style={{
                        display: "grid",
                        minHeight: "650px",
                        gridTemplateColumns: isAddPeripheralClicked
                            ? "2fr 1fr "
                            : "auto",
                        gridColumnGap: "4px",
                        marginBottom: isAddPeripheralClicked ? "70px" : "0px",
                        border: 0,
                    }}
                >
                    <DynamicTable
                        requestHeader={{
                            "Accept-Language": i18nextLng,
                            ...getAuthHeader,
                        }}
                        url={`${
                            process.env.REACT_APP_API_V2_URL
                        }/settings/cash_management?userId=${userID}&shopId=${
                            rowData[0] !== undefined ? rowData[0].shopId : ""
                        }&franchiseId=${franchiseID}&typeDisplay=notArchived`}
                        customJsxSideFilterButton={
                            isAddPeripheralClicked !== true ? (
                                <div className="d-flex justify-content-start align-items-center">
                                    <span
                                        onClick={() => {
                                            setEditedData([]);
                                            setIsAddPeripheralClicked(
                                                !isAddPeripheralClicked
                                            );
                                        }}
                                    >
                                        <CustomMainColorButtonWithIcon
                                            icon="PlusIcon"
                                            iconPosition="left"
                                            className="w-100"
                                            style={{ height: "0px" }}
                                            rounded
                                            variant="primary"
                                        >
                                            {t("Add device")}
                                        </CustomMainColorButtonWithIcon>
                                    </span>
                                </div>
                            ) : (
                                <div className="d-flex justify-content-start">
                                    <StyledIconButton
                                        icon="PlusIcon"
                                        className="bg-dark"
                                        rounded
                                        onClick={() => {
                                            if (isEdited === true)
                                                setIsInInitializationModalOpened(
                                                    true
                                                );
                                            else {
                                                setInputDesignation(false);
                                                setInputMarque(false);
                                            }
                                        }}
                                        disabled={
                                            editedData.length === 0
                                                ? false
                                                : true
                                        }
                                    >
                                        <PlusIcon
                                            height={20}
                                            width={20}
                                            fill="white"
                                        />
                                    </StyledIconButton>
                                </div>
                            )
                        }
                        setDataIsUpdated={setIsDataCashManagementUpdated}
                        dataIsUpdated={isDataCashManagementUpdated}
                        showGlobalFilter
                        setData={setData}
                        actionColumn={customJsxComponent}
                        filterActive={filterActive}
                        setLocalFilterActive={setLocalFilterActive}
                        arrayOfCustomColumns={arrayOfCustomColumns}
                        minHeight="520px"
                        maxHeight="520px"
                    />
                    {isAddPeripheralClicked ? (
                        <CashManagementConfigure
                            setIsAddCashManagementClicked={
                                setIsAddPeripheralClicked!
                            }
                            isAddCashManagementClicked={isAddPeripheralClicked}
                            setDataIsUpdated={setIsDataCashManagementUpdated}
                            editedData={editedData}
                            setEditedData={setEditedData}
                            isAddNewCashManagementButtonClicked={
                                isAddNewCashManagementButtonClicked
                            }
                            shopId={rowData[0].shopId}
                            isEdited={isEdited}
                            setIsEdited={setIsEdited}
                            localShopId={[rowData[0].shopId]}
                            setInputDesignation={setInputDesignation}
                            inputDesignation={inputDesignation}
                            setInputMarque={setInputMarque}
                            inputMarque={inputMarque}
                            setInputIp={setInputIp}
                            inputIp={inputIp}
                            dataTable={data}
                            isConsult={false}
                            setIsConsult={() => {}}
                        />
                    ) : null}
                </div>
            </CardBody>
            {isModalDeleteAssociatePeripheralOpened === false ? (
                <ConfirmationDeleteMessage
                    isModalOpened={isModalOpened}
                    setIsModalOpened={setIsModalOpened}
                    setDataIsUpdated={setIsDataCashManagementUpdated}
                    text={t("Please confirm archivation of this device")}
                    message={t("The device was successfully archived")}
                    apiUrl={`${process.env.REACT_APP_API_V2_URL}/settings/cashManagement?userId=${userID}&shopId=${rowData[0].shopId}&franchiseId=${franchiseID}&isArchived=true`}
                    setGlobalDataIsUpdated={setDataIsUpdated}
                />
            ) : (
                <AlertDeletePeripheralMessage
                    text={t(
                        "This device is associated with one or more applications! Unable to perform delete action"
                    )}
                    isModalDeleteAssociatePeripheralOpened={
                        isModalDeleteAssociatePeripheralOpened
                    }
                    setIsModalDeleteAssociatePeripheralOpened={
                        setIsModalDeleteAssociatePeripheralOpened
                    }
                />
            )}
            {isInInitializationModalOpened === true ? (
                <ConfirmationInitializationMessage
                    isModalOpened={isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddNewCashManagementButtonClicked}
                    isClicked={isAddNewCashManagementButtonClicked}
                    setIsEdited={setIsEdited}
                />
            ) : null}
            {isConfirmationEditRunning === true ? (
                <ConfirmationMessageEditPeripheral
                    isModalOpened={isConfirmationEditRunning}
                    setIsModalOpened={setIsConfirmationEditRunning}
                    setCancel={setIsAddPeripheralClicked}
                    archive={false}
                />
            ) : null}
        </React.Fragment>
    );
}
